import type { FC } from "react";

import { Form } from "@/ui/components/form/Form";
import { Input } from "@/ui/components/form/Input";
import { Column } from "@/ui/components/layout/Column";
import { Grid } from "@/ui/components/layout/Grid";
import { Button } from "@/ui/components/primitives/Button";
import { type TRequestLoginCodeProps } from "./RequestLoginCode.config";
import { useRequestLoginCode } from "./useRequestLoginCode";
import { cn } from "@/ui/lib/utils";

export const RequestLoginCode: FC<TRequestLoginCodeProps> = (
  {
    email,
    submit = {},
    onSubmit,
    className,
    ...props
  },
) => {
  const {
    emailProps,
    submitLabel,
    submitProps,
  } = useRequestLoginCode({
    email,
    submit,
  });

  return (
    <div
      data-component="RequestLoginCode"
      className="w-full"
    >
      <Form
        {...props}
        onSubmit={onSubmit}
        className={cn(
          "w-full",
          className,
        )}
      >
        <Grid gap="4">
          <Column className="w-full">
            <Input
              {...emailProps}
            />
          </Column>
          <Column className="w-full">
            <Button
              {...submitProps}
              type="submit"
            >
              { submitLabel }
            </Button>
          </Column>
        </Grid>
      </Form>
    </div>
  );
};

RequestLoginCode.displayName = "RequestLoginCode";
